import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { dispatchApi } from '../api/services';
import toast from 'react-hot-toast';
import { format } from 'date-fns';
import { Truck } from 'lucide-react';

export default function DispatchBatches() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dispatchApi.list()
      .then((res) => setRows(res.data.batches || []))
      .catch((err) => toast.error(err.response?.data?.error || 'Failed to load'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <h1 className="text-2xl font-semibold text-gray-900 mb-4">Dispatch batches</h1>

      {loading && <div className="text-sm text-gray-500">Loading…</div>}

      {!loading && rows.length === 0 && (
        <div className="bg-white rounded-xl border border-gray-200 p-8 text-center">
          <Truck className="w-10 h-10 text-gray-300 mx-auto mb-3" />
          <p className="text-gray-600">No dispatch batches yet.</p>
        </div>
      )}

      {!loading && rows.length > 0 && (
        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-xs font-semibold uppercase text-gray-500">
              <tr>
                <th className="text-left px-4 py-3">Batch #</th>
                <th className="text-left px-4 py-3">Vendor</th>
                <th className="text-left px-4 py-3">Type</th>
                <th className="text-left px-4 py-3">Status</th>
                <th className="text-left px-4 py-3">XLSX</th>
                <th className="text-left px-4 py-3">Emailed</th>
                <th className="text-left px-4 py-3">Created</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((b) => (
                <tr key={b.id} className="border-t border-gray-100 hover:bg-gray-50">
                  <td className="px-4 py-3 font-medium text-blue-600">
                    <Link to={`/dispatch/${b.id}`}>{b.batch_number}</Link>
                  </td>
                  <td className="px-4 py-3">{b.vendor_name || b.vendor_id?.slice(0, 8)}</td>
                  <td className="px-4 py-3">
                    {b.is_reship_file
                      ? <span className="text-purple-700 font-medium">-RESHIP</span>
                      : <span className="text-gray-500">standard</span>}
                  </td>
                  <td className="px-4 py-3 capitalize">
                    {b.status}
                    {b.needs_revised_file && (
                      <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800 normal-case">
                        revised file needed
                      </span>
                    )}
                  </td>
                  <td className="px-4 py-3 font-mono text-xs">{b.xlsx_filename || '—'}</td>
                  <td className="px-4 py-3">
                    {b.emailed_to_vendor_at ? format(new Date(b.emailed_to_vendor_at), 'dd MMM HH:mm') : '—'}
                  </td>
                  <td className="px-4 py-3 text-gray-500">
                    {b.created_at && format(new Date(b.created_at), 'dd MMM HH:mm')}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
